import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import CandidateProfileComponent from "../../components/candidate/profile/CandidateProfileComponent";
import MasterDataService from '../../services/master-data-service';
import CandidateService from '../../services/candidate/candidate-service';
import toasterUtils from "../../utils/toaster-utils";
import IdNameModel from "../../models/common/IdNameModel";
import CandidateProfileModel from "../../models/candidate/response/CandidateProfileModel";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";

const CandidateProfileModelDefault = {
    candidateId: "",
    countryId: 0,
    cityId: 0,
    experienceId: 0,
    designationId: 0,
    currentPay: 0,
    noticePeriodId: 0,
    mobileNumber: 0,
    emailId: "",
    resumeTitle: "",
    restrictEmployerToViewProfile: false
};

const CandidateProfile = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [city, setCity] = useState<IdNameModel[]>([]);
    const [designation, setDesignation] = useState<IdNameModel[]>([]);
    const [experience, setExperience] = useState<IdNameModel[]>([]);
    const [noticePeriod, setNoticePeriod] = useState<IdNameModel[]>([]);
    const [candidateProfile, setCandidateProfile] = useState<CandidateProfileModel>(CandidateProfileModelDefault);
    const [refreshCandidateProfile, setRefreshCandidateProfile] = useState<number>(2);

    useEffect(() => {
        getExperience();
        getDesignation();
        getNoticePeriod();
        if (loggedInUser) {
            getCandidateProfile(loggedInUser.profileId);
        }
    }, []);

    const getCandidateProfile = (candidateId?: string) => {
        if (candidateId) {
            modalUtils.showLoader();
            CandidateService.getCandidateProfile(candidateId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCandidateProfile(res.data);
                getCity(res.data.countryId);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const getExperience = () => {
        MasterDataService.loadExperiences().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setExperience(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getCity = (targetValue: number) => {
        MasterDataService.loadCities(targetValue).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCity(res.items);
            setRefreshCandidateProfile(refreshCandidateProfile * 5);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getDesignation = () => {
        CandidateService.loadCandidateDesignation().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setDesignation(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getNoticePeriod = () => {
        MasterDataService.loadNoticePeriod().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setNoticePeriod(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> My Profile
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> MY PROFILE</h4>
            </div>
            <CandidateProfileComponent
                key={refreshCandidateProfile}
                objCandidateProfile={candidateProfile}
                experienceList={experience}
                cityList={city}
                designationList={designation}
                noticePeriodList={noticePeriod}
            />
        </Layout>
    );
};
export default CandidateProfile;